import Vue from 'vue'

const Resellers = {
  namespaced: true,

  state: {
    reseller: {},
    resellerName: null,
    resellers: []
  },

  mutations: {
    setResellers(state, resellers) {
      state.resellers = resellers || []
    },
    setReseller(state, reseller) {
      state.reseller = reseller || {}
      state.resellerName = state.reseller.name
    }
  },

  actions: {
    async getAll({ commit }, { search } = {}) {
      const params = { search }
      const response = await Vue.axios.get('/resellers', { params })
      const resellers = response.data.data
      commit('setResellers', resellers)
      return resellers
    },
    async get({ commit }, id) {
      let reseller = {}
      if (id) {
        const response = await Vue.axios.get(`/reseller/${id}`)
        reseller = response.data.data
      }
      commit('setReseller', reseller)
      return reseller
    },
    async createAndSet({ dispatch }, { name, item }) {
      const response = await Vue.axios.post('/reseller', { name })
      const { id } = response.data.data
      await dispatch('getAll')
      item.reseller_id = id
    },
    async createOrUpdate({ commit, state }) {
      let response
      if (state.reseller.id) {
        response = await Vue.axios.put(`/reseller/${state.reseller.id}`, state.reseller)
      } else {
        response = await Vue.axios.post('/reseller', state.reseller)
      }
      commit('setReseller', response.data.data)
    }
  }
}

export default Resellers
